export default __webpack_public_path__ + "static/media/landlord-rent-hero.88759e11.png";